import React from "react"
import okLogo from "../assets/ok.png"
import deleteLogo from "../assets/delete.png"
import { useDispatch } from "react-redux"
import { ToogleTodo, clearTodo, deleteTodo } from "../redux/action/todoAction"

const TodoItem = ({ completed, text, id }) => {
  const distpach=useDispatch()
  const handleToggle = () => {
    distpach(ToogleTodo(id))
    
  }

  const handleDelete = () => {
    distpach(deleteTodo(id))
  }

  const styled = {
    textDecoration: completed ? "line-through" : "none",
    backgroundColor: completed ? "#A9A9A9" : "lightgray",
    borderRadius: "5px",
  }

  return (
    <div style={styled} className="todo-list">
      <h2 className="todoText">{text}</h2>
      <div>
        <span>
          <img
            src={okLogo}
            className="ok-logo"
            alt="ok logo"
            onClick={handleToggle}
          />
        </span>
        <span>
          <img
            src={deleteLogo}
            className="delete-logo"
            alt="delete logo"
            onClick={handleDelete}
          />
        </span>
      </div>
    </div>
  )
}

export default TodoItem
